<template>
  <article class="layout-section -align-side">
    <figure class="layout-section__figure" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.intro.title }}</h2>
      <p>
        {{ wp.intro.text }}
      </p>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RegisterIntro',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.intro.image})`
    }
  }
}
</script>
